import React, { useEffect, useState } from "react";
import { Formik, FieldArray } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import AdMaxHeader from "./header";
import { updateAudioAds } from "../../../store/slices/authSlice";
import AudioModel from "../../../components/models/AudioModel";
import { toast } from "react-toastify";
import AdsUnpaid from "./AdsUnpaid";
import Swal from "sweetalert2";

const validationSchema = Yup.object({
  audios: Yup.array().of(
    Yup.object().shape({
      audio: Yup.string(),
      audioIdentifier: Yup.string().required("Audio Identifier is required"),
    })
  ),
});

const AudioAd = () => {
  const { user } = useSelector((state) => state.auth);
  const {
    attributes: { audioAds, enableAudioAds },
  } = user;
  const dispatch = useDispatch();
  const [deletedAudios, setDeletedAudios] = useState([]);
  const [audio, setAudio] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleDelete = (index) => {
    setDeletedAudios([...deletedAudios, index]);
  };

  const handleUndoDelete = (index) => {
    setDeletedAudios(deletedAudios.filter((i) => i !== index));
  };

  const handleClick = () => {
    if (enableAudioAds) {
      document.getElementById("fileInput").click();
    } else {
      Swal.fire("Not-Allowed", "Audio Ads is a premium feature that can be used in your application.<br> Please contact us for pricing: support@radiofxinc.com.");
    }
  }

  return (
    <div>
      <Formik
        initialValues={{
          audios: audioAds?.audios || [],
        }}
        validationSchema={validationSchema}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            const filteredAudios = values.audios.filter(
              (_, index) => !deletedAudios.includes(index)
            );

            const updatedValues = {
              ...values,
              audios: filteredAudios,
            };
            const isForStation = user?.attributes?.isOwner == false ? true : false;
            dispatch(
              updateAudioAds({
                values: { audioAds: updatedValues },
                message: "Audio Ad updated successfully",
                isForStation
              })
            );
            setDeletedAudios([])

            setSubmitting(false);
          } catch (error) {
            console.log(error.message);
          }
        }}
      >
        {(formik) => (
          <div className="section_main_div">
            <h1 className="section_heading">AdMax</h1>
            <AdMaxHeader />
            {!enableAudioAds && <AdsUnpaid title={"Audio Ads"} />}
            <div className="InnerHeading">
              <h4>Add Audio</h4>
              <h5 className="pb-2">
                Size: 2 MB
                <br />
                Types: (mp3, aac)
              </h5>
            </div>
            <form className="form_div" onSubmit={formik.handleSubmit}>
              <FieldArray name="audios">
                {({ remove }) => (
                  <>
                    {formik.values.audios?.map((audio, index) => (
                      <div
                        className="form-card"
                        key={index}
                        style={{ position: "relative" }}
                      >
                        <div
                          className="form-elements"
                          style={{ position: "relative", zIndex: 2 }}
                        >
                          <div className="d-flex">
                            <audio
                              src={audio.audio}
                              controls
                              style={{ width: "100%", maxWidth: "400px" }}
                            />
                            {!deletedAudios.includes(index) && (
                              <button
                                type="button"
                                onClick={() => handleDelete(index)}
                                style={{
                                  border: "0px",
                                  outline: "0px",
                                  cursor: "pointer",
                                  background: "none",
                                  marginLeft: "10px",
                                }}
                              >
                                Delete
                              </button>
                            )}
                          </div>
                          <div className="custom-form-group">
                            <label htmlFor={`audios.${index}.audioIdentifier`}>
                              Audio Identifier
                            </label>
                            <input
                              type="text"
                              id={`audios.${index}.audioIdentifier`}
                              {...formik.getFieldProps(
                                `audios.${index}.audioIdentifier`
                              )}
                              autoComplete="off"
                            />
                            <input
                              type="hidden"
                              id={`audios.${index}.audio`}
                              {...formik.getFieldProps(`audios.${index}.audio`)}
                              autoComplete="off"
                            />
                            {formik.touched.audios?.[index]?.audioIdentifier &&
                              formik.errors.audios?.[index]?.audioIdentifier ? (
                              <div className="error-text">
                                {formik.errors.audios[index].audioIdentifier}
                              </div>
                            ) : null}
                            <hr
                              className={
                                formik.touched.audios?.[index]
                                  ?.audioIdentifier &&
                                  formik.errors.audios?.[index]?.audioIdentifier
                                  ? "error-hr-line"
                                  : ""
                              }
                            />
                          </div>
                        </div>

                        {deletedAudios.includes(index) && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background: "rgba(0, 0, 0, 0.65)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 5,
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => handleUndoDelete(index)}
                              className="simpleBtn"
                            >
                              <span>UNDO DELETE</span>
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </FieldArray>

              {formik.values.audios?.length < 1 && (
                <div className="form-card">
                  <div
                    className="file-upload"
                    style={{
                      height: "100%",
                      border: "1px solid rgb(151, 151, 151)",
                      padding: "18px 40px",
                      cursor: "pointer",
                      fontWeight: 500,
                      textAlign: "center",
                      color: "rgb(74, 143, 226)",
                    }}
                    onClick={() => {handleClick()}}
                  >
                    <input
                      type="file"
                      id="fileInput"
                      accept="audio/mp3, audio/aac"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const maxSize = 2 * 1024 * 1024; // 2MB
                          const allowedTypes = [
                            "audio/mp3",
                            "audio/mpeg",
                            "audio/aac",
                          ];
                          if (!allowedTypes.includes(file.type)) {
                            toast.error(
                              "Invalid file type. Please upload an MP3 or AAC file."
                            );
                            return;
                          }
                          if (file.size > maxSize) {
                            toast.error(
                              "File size exceeds 2MB. Please upload a smaller file."
                            );
                            return;
                          }
                          setAudio(file);
                          setShowModal(true);
                        }
                      }}
                    />
                    + Add Audio file. Drop file
                  </div>
                </div>
              )}

              <div className="text-right">
                <div className="button-div">
                  <button
                    type="submit"
                    className="text-white"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </form>

            <AudioModel
              show={showModal}
              onClose={() => setShowModal(false)}
              audio={audio}
            />
          </div>
        )}
      </Formik>
    </div>
  );
};

export default AudioAd;
